const CTASection = () => {
  return (
    <section className="relative py-16 sm:py-24 bg-dark overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle, #2754F5 1px, transparent 1px)',
            backgroundSize: '30px 30px',
          }}
        ></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Icon */}
        <div className="w-16 h-16 sm:w-20 sm:h-20 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-6 backdrop-blur-sm">
          <i className="ri-customer-service-2-line text-3xl sm:text-4xl text-primary"></i>
        </div>

        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 break-words px-2">
          ¿Necesitas vaciar un piso en El Prat?
        </h2>

        {/* Description */}
        <p className="text-base sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed px-2">
          Presupuesto gratuito en 24 horas. Servicio discreto y profesional de <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong> y <strong>limpieza por síndrome de Diógenes</strong>. <a href="/empresa" className="underline hover:text-primary transition-colors cursor-pointer">Conoce más sobre nosotros</a>
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 px-4">
          <a
            href="tel:+34602365996"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 bg-primary text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg hover:bg-opacity-90 transition-all shadow-2xl hover:shadow-primary/50 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl sm:text-2xl"></i>
            <span>Llamar 602 36 59 96</span>
          </a>
          <a
            href="https://wa.me/34602365996?text=Hola,%20necesito%20información%20sobre%20vaciado%20de%20pisos"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 border-2 border-white text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-dark transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
            <span>WhatsApp Gratis</span>
          </a>
        </div>

        {/* Trust Elements */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-white/70 text-xs sm:text-sm px-4">
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-primary text-lg sm:text-xl flex-shrink-0"></i>
            <span className="whitespace-nowrap">Respuesta en 2 horas</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-primary text-lg sm:text-xl flex-shrink-0"></i>
            <span className="whitespace-nowrap">Servicio garantizado</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-calendar-check-line text-primary text-lg sm:text-xl flex-shrink-0"></i>
            <span className="whitespace-nowrap">Disponible 24/7</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
